export const config  = {
    AUTHORITY_URL:"https://login.microsoftonline.com", 
    TENANT_ID: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
    CLIENT_ID: "8a4bf8a7-cce2-41e4-b930-feb30e48cd6f",
    // BASE_URL:"http://10.1.41.137:5000",
    // BASE_URL: "https://aueuintgwqwap04.azurewebsites.net",
    // BASE_URL:"http://localhost:5000",
    BASE_URL:"https://auedsatppawap02.azurewebsites.net",
}